const ATTRIBUTES = {
  TRACK_EVENT: 'data-ga-track-event',
};

const gAEventOnce = new Set();

type UserTrackingData = {
  encryptedId?: string;
  hashedEmail?: string;
};

type TrackEventOptions = {
  eventAction: string;
  eventLabel?: string;
  userData?: UserTrackingData;
};

/**
 * Tracks event in GA
 */
const trackGAEvent = (eventAction: string, eventLabel: string = '') => {
  if (eventAction) {
    window.ecGa('trackEvent', { eventAction, eventLabel });
  }
};

/**
 * Tracks event in GA with user data for dataLayer
 * If userData is provided, it will be added to the dataLayer before tracking the event
 */
const trackGAEventWithUserData = ({ eventAction, eventLabel = '', userData }: TrackEventOptions) => {
  if (!eventAction) return;

  if (userData && (userData.encryptedId || userData.hashedEmail)) {
    const userDataForDataLayer = {
      u: {
        ...(userData.encryptedId && { huid: userData.encryptedId }),
        ...(userData.hashedEmail && { hue: userData.hashedEmail }),
      },
    };

    window.ecGa('pushToDataLayer', userDataForDataLayer);
  }

  trackGAEvent(eventAction, eventLabel);
};

const trackGAEventOnce = (eventAction: string, eventLabel: string = '') => {
  if (!gAEventOnce.has(eventAction + eventLabel)) {
    gAEventOnce.add(eventAction + eventLabel);
    trackGAEvent(eventAction, eventLabel);
  }
};

/**
 * Returns attribute to enable tracking the click in GA
 * Apply for links in app-shell that are not rehydrated client-side
 */
const getGATrackingAttrForSSR = (action: string, label: string): object => ({
  [ATTRIBUTES.TRACK_EVENT]: `${encodeURIComponent(action)},${encodeURIComponent(label)}`,
});

export { getGATrackingAttrForSSR, trackGAEvent, trackGAEventOnce, trackGAEventWithUserData };
export type { UserTrackingData };
